module.exports = __webpack_public_path__ + "img/BJ.37921078.png";